import { takeLatest, call, put, select, all } from 'redux-saga/effects';
import {
  requestInProcess,
  requestFinished,
  updateList,
  sendRequest,
  selectQueryParams
} from '../../../../../common/reducers/list/reducer';
import { timeoutCall } from '../../../../../utils/sagaHalper';
import MessengerService from '../../../services/MessengerService';

import { sendRequest as getMessengerMeStat } from '../../../../../common/reducers/data/reducer';

const meStatRN = 'messengerModule.objects.meStat';

function* roomMessagesListSaga(reducerName, action) {
  yield put(requestInProcess(reducerName));
  const queryParams = yield select(selectQueryParams, reducerName);
  let status = null;
  try {
    const result = yield call(
      timeoutCall,
      MessengerService.getMessagesFromUserRoom,
      action.payload,
      queryParams
    );
    if (result.response) {
      status = result.response.status;
      if (result.response.status) {
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.itemsById,
            itemsIds: result.destructData.itemsIds,
            pagination: result.destructData.pagination
          })
        );
        yield put(getMessengerMeStat(meStatRN));
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function* createSaga(reducerName) {
  yield all([
    takeLatest(
      sendRequest(`${reducerName}.list`).type,
      roomMessagesListSaga,
      `${reducerName}.list`
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/reducers/dynamic/roomMessages/saga.js